module.exports = __webpack_public_path__ + "static/img/unicorn.3dd8e00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unicorn.png
// module id = 1822
// module chunks = 5